export const manifest = {
  screens: {
    scr_59jwu6: { name: "Manager View", route: "/", state: {"view":"manager"}, position: {"x":160,"y":220} },
    scr_tujvi4: { name: "RVP View", route: "/", state: {"view":"rvp"}, position: {"x":2960,"y":220} },
    scr_aimdgq: { name: "Executive View", route: "/", state: {"view":"admin"}, position: {"x":1560,"y":220} },
  },
  sections: {
    sec_kh38e0: { name: "Dashboard Views", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_kh38e0", children: [
      { kind: "screen", id: "scr_59jwu6" },
      { kind: "screen", id: "scr_aimdgq" },
      { kind: "screen", id: "scr_tujvi4" },
    ] },
  ],
}
